import React, { useState, useEffect } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import FilterPanel from './components/FilterPanel';
import SearchBar from './components/SearchBar';
import SortControls from './components/SortControls';
import JobCard from './components/JobCard';
import ApplicationModal from './components/ApplicationModal';
import SavedSearches from './components/SavedSearches';
import RecentlyViewed from './components/RecentlyViewed';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const JobSearchApplication = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    location: 'all',
    industry: 'all',
    jobType: 'all',
    experience: 'all',
    salary: 'all',
    eligibility: [],
    workFromHome: false,
    workFromOffice: false,
    hybrid: false,
    posted24h: false,
    posted7d: false,
    posted30d: false
  });
  const [sortBy, setSortBy] = useState('relevance');
  const [viewMode, setViewMode] = useState('grid');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState([]);
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const mockJobs = [
  {
    id: 1,
    title: 'Frontend Developer',
    company: 'Tech Innovations Pvt Ltd',
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_177bc96c9-1764659450912.png",
    companyLogoAlt: 'Tech Innovations company logo with blue gradient background and modern typography',
    location: 'Mumbai, Maharashtra',
    type: 'Full Time',
    experience: 'Fresher - 2 years',
    salaryMin: 3,
    salaryMax: 6,
    deadline: '2026-03-15',
    rating: 4.2,
    reviews: 156,
    featured: true,
    urgent: false,
    description: 'We are looking for a passionate Frontend Developer to join our dynamic team. You will work on cutting-edge web applications using React, TypeScript, and modern CSS frameworks.',
    requirements: [
    'Bachelor\'s degree in Computer Science or related field',
    'Strong knowledge of React.js and JavaScript',
    'Experience with responsive design and CSS frameworks',
    'Good understanding of RESTful APIs'],

    skills: ['React', 'JavaScript', 'HTML/CSS', 'TypeScript', 'Git']
  },
  {
    id: 2,
    title: 'Software Development Intern',
    company: 'StartupHub Technologies',
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ca89a7b3-1764635718024.png",
    companyLogoAlt: 'StartupHub Technologies logo featuring orange rocket icon on white background',
    location: 'Bangalore, Karnataka',
    type: 'Internship',
    experience: 'Fresher',
    salaryMin: 0,
    salaryMax: 0,
    deadline: '2026-02-28',
    rating: 4.5,
    reviews: 89,
    featured: false,
    urgent: true,
    description: 'Join our internship program and gain hands-on experience in full-stack development. Work alongside experienced developers on real-world projects.',
    requirements: [
    'Currently pursuing B.Tech/B.E. in Computer Science',
    'Basic knowledge of programming languages',
    'Eagerness to learn and adapt',
    'Good communication skills'],

    skills: ['Python', 'Java', 'SQL', 'Problem Solving']
  },
  {
    id: 3,
    title: 'Data Analyst',
    company: 'Analytics Pro Solutions',
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1d70f710f-1767229314470.png",
    companyLogoAlt: 'Analytics Pro Solutions logo with green data visualization chart on dark background',
    location: 'Pune, Maharashtra',
    type: 'Full Time',
    experience: '1-3 years',
    salaryMin: 4,
    salaryMax: 8,
    deadline: '2026-03-20',
    rating: 4.0,
    reviews: 234,
    featured: true,
    urgent: false,
    description: 'Seeking a detail-oriented Data Analyst to transform raw data into actionable insights. You will work with large datasets and create comprehensive reports for stakeholders.',
    requirements: [
    'Bachelor\'s degree in Statistics, Mathematics, or related field',
    'Proficiency in SQL and data visualization tools',
    'Experience with Python or R for data analysis',
    'Strong analytical and problem-solving skills'],

    skills: ['SQL', 'Python', 'Excel', 'Tableau', 'Power BI']
  },
  {
    id: 4,
    title: 'UI/UX Designer',
    company: 'Creative Minds Studio',
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_15ddbfa02-1770150049736.png",
    companyLogoAlt: 'Creative Minds Studio logo with purple palette and brush icon on light background',
    location: 'Delhi NCR',
    type: 'Full Time',
    experience: '2-4 years',
    salaryMin: 5,
    salaryMax: 10,
    deadline: '2026-03-10',
    rating: 4.7,
    reviews: 178,
    featured: false,
    urgent: false,
    description: 'We are looking for a creative UI/UX Designer to craft intuitive and engaging user experiences. You will collaborate with product managers and developers to bring designs to life.',
    requirements: [
    'Bachelor\'s degree in Design or related field',
    'Strong portfolio showcasing UI/UX projects',
    'Proficiency in Figma, Adobe XD, or Sketch',
    'Understanding of user-centered design principles'],

    skills: ['Figma', 'Adobe XD', 'Prototyping', 'User Research', 'Wireframing']
  },
  {
    id: 5,
    title: 'Backend Developer',
    company: 'CloudScale Systems',
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1089c8bdf-1767091768518.png",
    companyLogoAlt: 'CloudScale Systems logo with blue cloud icon and server graphics on white background',
    location: 'Hyderabad, Telangana',
    type: 'Full Time',
    experience: '3-5 years',
    salaryMin: 8,
    salaryMax: 15,
    deadline: '2026-03-25',
    rating: 4.3,
    reviews: 201,
    featured: true,
    urgent: true,
    description: 'Join our backend team to build scalable and robust server-side applications. You will work with microservices architecture and cloud technologies.',
    requirements: [
    'Bachelor\'s degree in Computer Science or related field',
    'Strong experience with Node.js or Python',
    'Knowledge of database design and optimization',
    'Experience with AWS or Azure cloud services'],

    skills: ['Node.js', 'Python', 'MongoDB', 'AWS', 'Docker']
  },
  {
    id: 6,
    title: 'Digital Marketing Intern',
    company: 'Growth Marketing Agency',
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1b03d2d36-1764768133847.png",
    companyLogoAlt: 'Growth Marketing Agency logo with red megaphone icon and growth chart on gradient background',
    location: 'Chennai, Tamil Nadu',
    type: 'Internship',
    experience: 'Fresher',
    salaryMin: 0,
    salaryMax: 0,
    deadline: '2026-02-25',
    rating: 4.1,
    reviews: 67,
    featured: false,
    urgent: false,
    description: 'Learn digital marketing strategies and tools while working on real client campaigns. Gain experience in SEO, social media marketing, and content creation.',
    requirements: [
    'Currently pursuing degree in Marketing or related field',
    'Basic understanding of digital marketing concepts',
    'Creative mindset and good writing skills',
    'Familiarity with social media platforms'],

    skills: ['SEO', 'Social Media', 'Content Writing', 'Google Analytics']
  },
  {
    id: 7,
    title: 'Full Stack Developer',
    company: 'Enterprise Solutions Ltd',
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_13db8ee92-1769298658613.png",
    companyLogoAlt: 'Enterprise Solutions Ltd logo with navy blue hexagon pattern and modern font on white background',
    location: 'Kolkata, West Bengal',
    type: 'Full Time',
    experience: '2-5 years',
    salaryMin: 6,
    salaryMax: 12,
    deadline: '2026-03-18',
    rating: 4.4,
    reviews: 145,
    featured: true,
    urgent: false,
    description: 'We need a versatile Full Stack Developer to work on enterprise-level applications. You will handle both frontend and backend development using modern tech stacks.',
    requirements: [
    'Bachelor\'s degree in Computer Science or related field',
    'Experience with React and Node.js',
    'Knowledge of database management',
    'Understanding of DevOps practices'],

    skills: ['React', 'Node.js', 'PostgreSQL', 'Docker', 'CI/CD']
  },
  {
    id: 8,
    title: 'Business Analyst',
    company: 'Consulting Partners India',
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_13d6b90a0-1764762952733.png",
    companyLogoAlt: 'Consulting Partners India logo with gold briefcase icon and professional typography on dark background',
    location: 'Ahmedabad, Gujarat',
    type: 'Full Time',
    experience: '1-3 years',
    salaryMin: 5,
    salaryMax: 9,
    deadline: '2026-03-12',
    rating: 4.2,
    reviews: 112,
    featured: false,
    urgent: true,
    description: 'Seeking a Business Analyst to bridge the gap between business needs and technical solutions. You will gather requirements and create detailed documentation.',
    requirements: [
    'Bachelor\'s degree in Business Administration or related field',
    'Strong analytical and problem-solving skills',
    'Experience with requirement gathering',
    'Excellent communication and presentation skills'],

    skills: ['Business Analysis', 'SQL', 'Excel', 'JIRA', 'Documentation']
  }];


  const savedSearches = [
  {
    id: 1,
    name: 'Frontend Jobs in Mumbai',
    criteria: 'Location: Mumbai, Industry: IT, Experience: Fresher-2 years'
  },
  {
    id: 2,
    name: 'Internships in Bangalore',
    criteria: 'Location: Bangalore, Type: Internship, Posted: Last 7 days'
  },
  {
    id: 3,
    name: 'High Salary Tech Jobs',
    criteria: 'Industry: IT, Salary: ₹8+ LPA, Experience: 3-5 years'
  }];


  const [recentlyViewed, setRecentlyViewed] = useState([
  mockJobs?.[0],
  mockJobs?.[2],
  mockJobs?.[4]]
  );

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleClearFilters = () => {
    setFilters({
      location: 'all',
      industry: 'all',
      jobType: 'all',
      experience: 'all',
      salary: 'all',
      eligibility: [],
      workFromHome: false,
      workFromOffice: false,
      hybrid: false,
      posted24h: false,
      posted7d: false,
      posted30d: false
    });
  };

  const handleSearch = () => {
    console.log('Searching with query:', searchQuery);
  };

  const handleApply = (job) => {
    setSelectedJob(job);
  };

  const handleSubmitApplication = (jobId, formData) => {
    setAppliedJobs((prev) => [...prev, jobId]);
    setSelectedJob(null);
    setShowSuccessMessage(true);
    setTimeout(() => setShowSuccessMessage(false), 5000);
  };

  const handleBookmark = (jobId) => {
    setBookmarkedJobs((prev) =>
    prev?.includes(jobId) ?
    prev?.filter((id) => id !== jobId) :
    [...prev, jobId]
    );
  };

  const handleLoadSearch = (search) => {
    console.log('Loading saved search:', search);
  };

  const handleDeleteSearch = (searchId) => {
    console.log('Deleting search:', searchId);
  };

  const handleViewJob = (job) => {
    if (!recentlyViewed?.find((j) => j?.id === job?.id)) {
      setRecentlyViewed((prev) => [job, ...prev?.slice(0, 5)]);
    }
  };

  const filteredJobs = mockJobs?.filter((job) => {
    if (filters?.location !== 'all' && !job?.location?.toLowerCase()?.includes(filters?.location)) {
      return false;
    }
    if (filters?.jobType !== 'all' && job?.type !== filters?.jobType) {
      return false;
    }
    if (searchQuery && !job?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) &&
    !job?.company?.toLowerCase()?.includes(searchQuery?.toLowerCase())) {
      return false;
    }
    return true;
  });

  const sortedJobs = [...filteredJobs]?.sort((a, b) => {
    switch (sortBy) {
      case 'salary-high':
        return b?.salaryMax - a?.salaryMax;
      case 'salary-low':
        return a?.salaryMin - b?.salaryMin;
      case 'deadline':
        return new Date(a.deadline) - new Date(b.deadline);
      case 'posted':
        return b?.id - a?.id;
      default:
        return 0;
    }
  });

  useEffect(() => {
    document.body.style.overflow = selectedJob ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [selectedJob]);

  return (
    <MainLayout>
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-card-foreground mb-2">
          Find Your Dream Job
        </h1>
        <p className="text-sm md:text-base text-muted-foreground">
          Discover opportunities that match your skills and aspirations
        </p>
      </div>
      {showSuccessMessage &&
      <div className="mb-6 p-4 bg-success/10 border border-success/20 rounded-lg flex items-start gap-3">
          <Icon name="CheckCircle2" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-medium text-card-foreground mb-1">
              Application Submitted Successfully!
            </h3>
            <p className="text-xs text-muted-foreground">
              Your application has been sent to the employer. You can track its status in the Applications section.
            </p>
          </div>
        </div>
      }
      <div className="mb-6">
        <SearchBar
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          onSearch={handleSearch}
          onToggleFilters={() => setIsFilterOpen(!isFilterOpen)} />

      </div>
      <SavedSearches
        searches={savedSearches}
        onLoadSearch={handleLoadSearch}
        onDeleteSearch={handleDeleteSearch} />

      <RecentlyViewed
        jobs={recentlyViewed}
        onViewJob={handleViewJob}
        onApply={handleApply} />

      <div className="flex gap-6">
        <FilterPanel
          filters={filters}
          onFilterChange={handleFilterChange}
          resultCount={filteredJobs?.length}
          onClearFilters={handleClearFilters}
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)} />


        <div className="flex-1 min-w-0">
          <div className="mb-6">
            <SortControls
              sortBy={sortBy}
              onSortChange={setSortBy}
              viewMode={viewMode}
              onViewModeChange={setViewMode} />

          </div>

          {sortedJobs?.length === 0 ?
          <div className="text-center py-12 md:py-16">
              <Icon name="Search" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
              <h3 className="text-lg md:text-xl font-heading font-semibold text-card-foreground mb-2">
                No jobs found
              </h3>
              <p className="text-sm md:text-base text-muted-foreground mb-6">
                Try adjusting your filters or search criteria
              </p>
              <Button variant="outline" onClick={handleClearFilters}>
                Clear All Filters
              </Button>
            </div> :

          <div className={`grid gap-4 md:gap-6 ${
          viewMode === 'grid' ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1'}`
          }>
              {sortedJobs?.map((job) =>
            <JobCard
              key={job?.id}
              job={job}
              onApply={handleApply}
              onBookmark={handleBookmark}
              isBookmarked={bookmarkedJobs?.includes(job?.id)}
              hasApplied={appliedJobs?.includes(job?.id)} />

            )}
            </div>
          }
        </div>
      </div>
      {selectedJob &&
      <ApplicationModal
        job={selectedJob}
        onClose={() => setSelectedJob(null)}
        onSubmit={handleSubmitApplication} />

      }
      {isFilterOpen &&
      <div
        className="fixed inset-0 bg-background/80 backdrop-blur-sm z-30 lg:hidden"
        onClick={() => setIsFilterOpen(false)} />

      }
    </MainLayout>);

};

export default JobSearchApplication;